import "./SideNavIcon.scss";

export default function SideNavIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.457"
      height="16.703"
      viewBox="0 0 21.457 16.703"
    >
      <g id="Group_804" data-name="Group 804" transform="translate(0 1)">
        <line id="Line_4" data-name="Line 4" className="side-nav" x1="21.457" />
        <line
          id="Line_5"
          data-name="Line 5"
          className="side-nav"
          x1="21.457"
          transform="translate(0 4.852)"
        />
        <line
          id="Line_6"
          data-name="Line 6"
          className="side-nav"
          x1="15"
          transform="translate(6.457 9.703)"
        />
        <line
          id="Line_7"
          data-name="Line 7"
          className="side-nav"
          x1="11"
          transform="translate(10.457 14.703)"
        />
      </g>
    </svg>
  );
}
